// Sample questions for the chat interface
// Replace these with your own sample questions

const sampleQuestions = [
  "How can you help me today?",
  "What services do you offer?",
  "Can you explain how this works?",
  "What are the benefits?",
  "How much does it cost?",
  "Is this right for my situation?",
  "What's the next step?",
  "How long does the process take?",
  "What do I need to get started?",
  "Can you give me an example?"
];

export function getRandomProspectQuestions(count: number = 2): string[] {
  const shuffled = [...sampleQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

export function getAllProspectQuestions(): string[] {
  return [...sampleQuestions];
}

// For customization - replace with your own questions
export const customizeQuestions = (newQuestions: string[]) => {
  sampleQuestions.length = 0;
  sampleQuestions.push(...newQuestions);
};